import React, { FC } from 'react';
import cn from 'classnames';

const listStyleType1 = "before:content-['•']";
const listStyleType2 = "before:content-['○']";
const listStyle = 'before:mr-0.5 before:text-astronautBlue-500';

const Integration: FC = () => {
  return (
    <div>
      <p className="mb-1">Процес інтеграціі поділений на дві частини:</p>
      <ul className="indent-6 mb-1">
        <li>
          <span className={cn(listStyleType1, listStyle)}>
            Завантаження даних про залишки товарів та аптеки
          </span>
        </li>
        <li>
          <span className={cn(listStyleType1, listStyle)}>
            Обробка замовлень
          </span>
        </li>
      </ul>
      <p className="mb-1">Є кілька варіантів інтеграції з сервісом:</p>
      <ul className="indent-6 mb-1">
        <li className="mb-1">
          <span className={cn(listStyleType1, listStyle)}>
            Повністю через API LikiE
            <ul className="indent-18">
              <li>
                <span className={cn(listStyleType2, listStyle)}>
                  Раз на добу партнер завантажує дані про аптеки
                </span>
              </li>
              <li>
                <span className={cn(listStyleType2, listStyle)}>
                  Регулярно партнер завантажує дані про залишки в аптеках (повні
                  або часткові)
                </span>
              </li>
              <li>
                <span className={cn(listStyleType2, listStyle)}>
                  Періодично партнер опитує API для отримання нових бронювань
                  (по всій або по одній аптеці)
                </span>
              </li>
              <li>
                <span className={cn(listStyleType2, listStyle)}>
                  При зміні статусу бронювання партнер відправляє в API
                  актуальний статус
                </span>
              </li>
            </ul>
          </span>
        </li>
        <li className="indent-6 mb-1">
          <span className={cn(listStyleType1, listStyle)}>
            Через API партнера (ви надаєте свій API)
            <ul className="indent-18">
              <li>
                <span className={cn(listStyleType2, listStyle)}>
                  Раз на добу ми викачуємо дані про аптеки
                </span>
              </li>
              <li>
                <span className={cn(listStyleType2, listStyle)}>
                  За узгодженим з вами розкладом ми викачуємо залишки по всіх
                  аптеках або викачуємо змінені залишки
                </span>
              </li>
              <li>
                <span className={cn(listStyleType2, listStyle)}>
                  При надходженні бронювань, ми відправляємо їх до вашого API
                </span>
              </li>
              <li>
                <span className={cn(listStyleType2, listStyle)}>
                  При оновленні статусу бронювання, ми відправляємо його до
                  вашого API
                </span>
              </li>
              <li>
                <span className={cn(listStyleType2, listStyle)}>
                  Періодично опитуємо ваше API для отримання оновлень статусу
                  бронювання
                </span>
              </li>
            </ul>
          </span>
        </li>
        <li className="indent-6 mb-1">
          <span className={cn(listStyleType1, listStyle)}>
            Гібридна інтеграція, яка працює за принципом &quot;у кого оновилися
            дані, той і робить API виклик&quot;
            <ul className="indent-18">
              <li>
                <span className={cn(listStyleType2, listStyle)}>
                  Раз на добу ми викачуємо дані про аптеки
                </span>
              </li>
              <li>
                <span className={cn(listStyleType2, listStyle)}>
                  Раз на 5 хвилин партнер надсилає зміни по залишкам
                </span>
              </li>
              <li>
                <span className={cn(listStyleType2, listStyle)}>
                  При надходженні бронювань, ми відправляємо їх до вашого API
                </span>
              </li>
              <li>
                <span className={cn(listStyleType2, listStyle)}>
                  При оновленні статусу бронювання партнер відправляє в API
                  актуальний статус бронювання
                </span>
              </li>
            </ul>
          </span>
        </li>
      </ul>
    </div>
  );
};

export default Integration;
